import React, { forwardRef } from 'react';

import Input from '.';

import { SuffixText } from './styled';

const InputNormalComponent = forwardRef(({
  suffixText,
  ...props
}, ref) => {
  return (
    <Input {...props} ref={ref}>
      {suffixText ? (
        <SuffixText>
          {suffixText}
        </SuffixText>
      ) : null}
    </Input>
  );
});

export default InputNormalComponent;
